import React from 'react';

type Props = {
	heading: string;
	subHeading: string;
	perks: {
		title: string;
		description: string;
		image: string;
	}[];
};

const Perks = ({ heading, subHeading, perks }: Props) => {
	return (
		<div id="perks">
			<div className="heading">
				<p>{subHeading}</p>
				<h3>{heading}</h3>
			</div>
			<ul className="perks-list">
				{perks.map(perk => {
					if (perk.title === 'Get Rewarded') {
						return (
							<li className="perk" key={perk.title}>
								<img src={perk.image} alt="perk" />
								<div className="layer"></div>
								<div className="copy">
									<h3>{perk.title}</h3>
									<p>{perk.description}</p>
									<ul className="reward-list">
										<li className="reward-list-item">Service awards</li>
										<li className="reward-list-item">Quarterly bonuses</li>
										<li className="reward-list-item">Split testing bonuses</li>
										<li className="reward-list-item">Internal Reward Programs</li>
									</ul>
								</div>
							</li>
						);
					} else
						return (
							<li className="perk" key={perk.title}>
								<img src={perk.image} alt="perk" />
								<div className="layer"></div>
								<div className="copy">
									<h3>{perk.title}</h3>
									<p>{perk.description}</p>
								</div>
							</li>
						);
				})}
			</ul>
		</div>
	);
};

export default Perks;
